<div class="container-fluid full-height">
  <div style="display:flex; height:100%;">
    <div class="login-image" style="flex: 0 0 66.666%; display: none;" [class.d-md-block]="true"></div>

    <div class="login-form" style="flex: 0 0 33.333%;">
      <div class="text-center">
        <img src="../../../../assets/images/logo.png" alt="Synergetics Logo" style="width: 280px;">
      </div>

      <h4 class="login-title text-center">Reset Password</h4>
      <div class="text-center">Enter the 6-digit code sent to your email and choose a new password</div>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassword()">
        <div>
          <label style="padding-bottom: 5px;">Email Address</label>
          <input
            type="email"
            matInput
            formControlName="loginId"
            placeholder="Enter your email address"
            autocomplete="email"
            [class.is-invalid]="loginId?.invalid && loginId?.touched">
          <div class="invalid-feedback" *ngIf="loginId?.invalid && loginId?.touched">
            <div *ngIf="loginId?.errors?.['required']">Email is required</div>
            <div *ngIf="loginId?.errors?.['email']">Please enter a valid email address</div>
          </div>
        </div>

        <div>
          <label style="padding-bottom: 5px;">
            Verification Code
            <button
              type="button"
              mat-button
              (click)="resendOtp()"
              title="Resend Code">
              Resend Code
            </button>
          </label>
          <input
            type="text"
            matInput
            class="text-center letter-spacing"
            formControlName="otpCode"
            placeholder="000000"
            maxlength="6"
            autocomplete="one-time-code"
            [class.is-invalid]="otpCode?.invalid && otpCode?.touched">
          <div class="invalid-feedback" *ngIf="otpCode?.invalid && otpCode?.touched">
            <div *ngIf="otpCode?.errors?.['required']">Verification code is required</div>
            <div *ngIf="otpCode?.errors?.['pattern']">Please enter a valid 6-digit code</div>
          </div>
        </div>

        <div>
          <label style="padding-bottom: 5px;">New Password</label>
          <div class="input-group">
            <input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="newPassword"
              matInput
              placeholder="Enter new password"
              autocomplete="new-password"
              [class.is-invalid]="newPassword?.invalid && newPassword?.touched">
            <button
              type="button"
              mat-stroked-button
              (click)="togglePasswordVisibility('password')">
              <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="newPassword?.invalid && newPassword?.touched">
            <div *ngIf="newPassword?.errors?.['required']">New password is required</div>
            <div *ngIf="newPassword?.errors?.['minlength']">Password must be at least 8 characters</div>
            <div *ngIf="newPassword?.errors?.['maxlength']">Password must not exceed 100 characters</div>
            <div *ngIf="newPassword?.errors?.['passwordStrength']">
              Password must contain:
              <ul>
                <li [class.text-success]="newPassword?.errors?.['passwordStrength']?.hasUpperCase"
                    [class.text-danger]="!newPassword?.errors?.['passwordStrength']?.hasUpperCase">
                  At least one uppercase letter
                </li>
                <li [class.text-success]="newPassword?.errors?.['passwordStrength']?.hasLowerCase"
                    [class.text-danger]="!newPassword?.errors?.['passwordStrength']?.hasLowerCase">
                  At least one lowercase letter
                </li>
                <li [class.text-success]="newPassword?.errors?.['passwordStrength']?.hasNumeric"
                    [class.text-danger]="!newPassword?.errors?.['passwordStrength']?.hasNumeric">
                  At least one number
                </li>
                <li [class.text-success]="newPassword?.errors?.['passwordStrength']?.hasSpecialChar"
                    [class.text-danger]="!newPassword?.errors?.['passwordStrength']?.hasSpecialChar">
                  At least one special character (&#64;$!%*?&amp;)
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div>
          <label style="padding-bottom: 5px;">Confirm New Password</label>
          <div class="input-group">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              matInput
              placeholder="Confirm new password"
              autocomplete="new-password"
              [class.is-invalid]="(confirmPassword?.invalid && confirmPassword?.touched) || (resetPasswordForm.errors?.['passwordMismatch'] && confirmPassword?.touched)">
            <button
              type="button"
              mat-stroked-button
              (click)="togglePasswordVisibility('confirm')">
              <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="(confirmPassword?.invalid && confirmPassword?.touched) || (resetPasswordForm?.errors?.['passwordMismatch'] && confirmPassword?.touched)">
            <div *ngIf="confirmPassword?.errors?.['required']">Password confirmation is required</div>
            <div *ngIf="resetPasswordForm?.errors?.['passwordMismatch'] && !confirmPassword?.errors?.['required']">
              Passwords do not match
            </div>
          </div>
        </div>

        <div>
          <button
            type="submit"
            mat-flat-button color="primary"
            class="btn-block"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
            {{ isLoading ? 'Resetting Password...' : 'Reset Password' }}
          </button>
        </div>
      </form>

      <div class="text-center">
        <a href="#" (click)="goBackToForgotPassword()" class="text-primary">
          ← Back to Forgot Password
        </a>
        |
        <a href="#" (click)="goBackToLogin()" class="text-primary">
          Back to Sign In
        </a>
      </div>

      <div class="alert alert-info">
        <small>
          <i class="fas fa-info-circle"></i>
          The verification code expires in 15 minutes. If you haven't received it, check your spam folder or click "Resend Code".
        </small>
      </div>
    </div>
  </div>
</div>
